import React from "react"
import {
  Card,
  Descriptions,
  Drawer,
  List,
  Spin,
  Statistic,
  Row,
  Col,
  Tag,
  notification,
} from "antd"
import { useAppData } from "src/store/app-data"
import api from "src/api"
import styled from "styled-components"

const statusMap = {
  pending: { color: "default", text: "Ожидание" },
  processing: { color: "processing", text: "В процессе" },
  completed: { color: "success", text: "Завершено" },
  failed: { color: "error", text: "Ошибка" },
}

export function DetailDrawer({ distributionId, onClose }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const [isLoading, setIsLoading] = React.useState(true)
  const [data, setData] = React.useState(null)

  React.useEffect(() => {
    if (distributionId) {
      loadDetail()
    }
  }, [distributionId])

  async function loadDetail() {
    setIsLoading(true)
    try {
      const response = await api.get(`bonus-distributions/${distributionId}`, {
        useV2Api: true,
      })
      setData(response.data?.item ?? null)
    } catch (error) {
      console.error("Ошибка загрузки", error)
      notification.error({ message: "Ошибка загрузки" })
    } finally {
      setIsLoading(false)
    }
  }

  const status = statusMap[data?.status] || { color: "default", text: data?.status }

  return (
    <StyledDrawer
      width={layoutConfig.isMobile ? "95%" : "60%"}
      title={`Рассылка #${distributionId}`}
      onClose={onClose}
      open
    >
      {isLoading ? (
        <SpinWrapper><Spin size="large" /></SpinWrapper>
      ) : data ? (
        <>
          <Descriptions column={{ xs: 1, sm: 2 }} size="small" bordered>
            <Descriptions.Item label="Название">
              {data.title}
            </Descriptions.Item>
            <Descriptions.Item label="Статус">
              <Tag color={status.color}>{status.text}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Тип поиска">
              {data.lookup_type === "phone" ? "Телефон" : "GUID"}
            </Descriptions.Item>
            <Descriptions.Item label="Баллы">
              {data.amount}
            </Descriptions.Item>
            <Descriptions.Item label="Создано">
              {data.created_at}
            </Descriptions.Item>
            <Descriptions.Item label="Запущено">
              {data.started_at ?? "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Завершено">
              {data.completed_at ?? "—"}
            </Descriptions.Item>
            {data.error_message && (
              <Descriptions.Item label="Ошибка" span={2}>
                <span style={{ color: "red" }}>{data.error_message}</span>
              </Descriptions.Item>
            )}
          </Descriptions>

          <StyledStatsRow gutter={16}>
            <Col xs={8}>
              <Card size="small">
                <Statistic title="Всего строк" value={data.total_rows} />
              </Card>
            </Col>
            <Col xs={8}>
              <Card size="small">
                <Statistic
                  title="Отправлено"
                  value={data.sent_count}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col xs={8}>
              <Card size="small">
                <Statistic
                  title="Не отправлено"
                  value={data.failed_count}
                  valueStyle={{
                    color: data.failed_count > 0 ? "#cf1322" : undefined,
                  }}
                />
              </Card>
            </Col>
          </StyledStatsRow>

          {data.failed_items && data.failed_items.length > 0 && (
            <Card
              size="small"
              title={`Не найденные идентификаторы (${data.failed_items.length})`}
              style={{ marginTop: 16 }}
            >
              <StyledList
                size="small"
                dataSource={data.failed_items}
                renderItem={(item) => (
                  <List.Item>
                    <code>{item}</code>
                  </List.Item>
                )}
                pagination={
                  data.failed_items.length > 50
                    ? { pageSize: 50, size: "small" }
                    : false
                }
              />
            </Card>
          )}
        </>
      ) : null}
    </StyledDrawer>
  )
}

const StyledDrawer = styled(Drawer)``
const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 80px 0;
`
const StyledStatsRow = styled(Row)`
  margin-top: 16px;
`
const StyledList = styled(List)`
  max-height: 400px;
  overflow-y: auto;
`
